<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        title='Crear haber o descuento'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'
    import AssetDiscountFields from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountFields'
    //
    export default {
        name: 'asset-discount-create',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            formProps() {
                return {
                    fields: AssetDiscountFields,
                }
            }
        },
        data() {
            return {
                formData: new AssetDiscountModel(),
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(AssetDiscountModel, error.response.data))
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'asset-discount-list' })
            },

            /**
             * 
             */
            submit() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Haber (o descuento) agregado exitosamente.')
            },

            /**
             *
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },
        },
        mounted() {
            this.setTitleTopBar('Crear haber o descuento')
        },
    }
</script>